<template>
    <div class="formit-multicheckbox-wrap">
        <span v-for="(option, key) in selectOptions" :key="key">
            <label>
            <input
                ref="input"
                type="checkbox"
                :name="name"
                v-bind="attributes"
                :value="key"
                :checked="isSelected(key)"
                @change="onChange"
            >
            {{option}}</label><br/>
        </span>
    </div>
</template>

<script>
import basefield from '../../mixins/basefield'

export default {
	name: 'formit-multicheckbox',
    mixins: [basefield],
    data() {
        return {
            checkedItems: []
        }
    },
    created() {
        this.checkedItems = this.currentValue
    },
    methods: {
        isSelected(option) {
            return this.currentValue.includes(option)
        },
        onChange(event) {
            if( event.target.checked === true ) {
                this.checkedItems.push( event.target.value )
            } else {
                this.checkedItems.splice( this.checkedItems.indexOf( event.target.value ) , 1)
            }
            this.$emit('input', this.checkedItems );
        }
    }
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-formit-fields/src/components/multicheckbox/multicheckbox.vue